angular.module('stock.articles.caArticleStocksHistory', [])
.component('caArticleStocksHistory',{
    templateUrl: 'main/stock/articles/articleStocksHistory/articleStocksHistory.component.tpl.html',
    bindings: {
        articleId: '<',
        locationId: '<',
        articleVariantId: '<',
        showSum: '<',
        navigated: '&',
        disabled: '<'
    },
    controllerAs: 'vm',
    controller: controller
});

// @ngInject
function controller($state, $window, $translate, StockApiService, loadSpinnerService) {
    var vm = this;

    //Properties
    var previousArticleId, previousLocationId, previousArticleVariantId;
    vm.rowData = [];
    vm.displayedRows = [];
    vm.transGrid = {};
    vm.transGrid.columns = [];
    vm.transGrid.rows = [];
    vm.stockTransactions = [];
    vm.elementsPerPage = 15;
    vm.currentPage = 1;

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.goToReference = goToReference;
    vm.showLink = showLink;
    vm.pageChanged = pageChanged;

    function onInit() {

    }

    function onChanges() {
        if (!vm.disabled) {
            if (vm.articleId && vm.locationId && vm.articleVariantId &&
                (previousArticleId !== vm.articleId || previousLocationId !== vm.locationId || previousArticleVariantId !== vm.articleVariantId)) {
                previousArticleId = vm.articleId;
                previousLocationId = vm.locationId;
                previousArticleVariantId = vm.articleVariantId;

                loadSpinnerService.start('mainSpinner');
                StockApiService
                    .getStockTransactionsForArticleAndLocation(
                        {
                            articleId: vm.articleId,
                            locationId: vm.locationId,
                            variantDetailId: vm.articleVariantId
                        }
                    )
                    .then(function(data) {
                        vm.stockTransactions = data;
                        setUpGridData();
                        loadGridData();
                    }).finally(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
            }
        }
    }

    function setUpGridData() {
        vm.transGrid.columns = [];

        vm.transGrid.columns.push({ id: 'accountingDate', name: $translate.instant('common.date') });
        vm.transGrid.columns.push({ id: 'transactionType', name: $translate.instant('stocktransaction.transactionType') });
        vm.transGrid.columns.push({ id: 'referenceDescription', name: $translate.instant('stocktransaction.referenceDescription') });

        var columns = getDataColumns();

        // Add dynamic columns
        _.forEach(columns, function(variantDetail) {
            vm.transGrid.columns.push({ id: variantDetail.variantDetailName, name: variantDetail.variantDetailName });
        });
    }

    function showLink(referenceType) {
        //NoReference, Order, Sale, BalanceChange, Delivery
        if (referenceType === 'noReference') {
            return false;
        } else if (referenceType === 'order') {
            return true;
        } else if (referenceType === 'sale') {
            return false;
        } else if (referenceType === 'balanceChange') {
            return false;
        } else if (referenceType === 'delivery') {
            return false;
        }
    }

    function goToReference(e, stockTransaction) {
        e.preventDefault();

        if (stockTransaction.referenceType === 'order') {
            // Go directly to the order
            if(stockTransaction.referenceId && stockTransaction.referenceId !== 0){
                $window.open($state.href('order.ordersearch', { orderId: stockTransaction.referenceId }), '_blank');
            }
            // Go to search for the order
            else
            {
                $window.open($state.href('order.ordersearch', {
                    searchTerm: '' + stockTransaction.referenceDescription,
                    showOnlyUndeliveredOrders: false,
                    orderTypes: [] //Has the same effect as setting 'All'
                }), '_blank');
            }

            if (vm.navigated) {
                vm.navigated();
            }
        }

        return false;
    }

    function getDataColumns() {
        var columns = [];
        var articleVariants = [];

        _.forEach(vm.stockTransactions, function(stockTransaction) {
            articleVariants.push(stockTransaction.articleVariant);
        });

        // Group by nested variantDetail2 in the current articleVariants
        columns = _.groupBy(articleVariants, function(variant) {
            return variant.variantDetail2.variantDetailName;
        });
        // Get the variantDetail2 from each group in an array
        columns = _.reduce(columns, function(newArray, val, key) {
            newArray.push(val[0].variantDetail2);
            return newArray;
        }, []);

        return _.sortBy(columns, 'sortOrder');
    }

    function loadGridData() {

        var rows = [];

        _.forEach(vm.stockTransactions, function (stockTransaction) {
            var r = {};

            r.accountingDate = moment(stockTransaction.accountingDate).format('YYYY-MM-DD');
            r.comment = stockTransaction.comment;
            r.transactionType = stockTransaction.stockTransactionType.stockTransactionTypeName;
            r.systemTransactionType = stockTransaction.stockTransactionType.systemTransactionType.toLowerCase();
            r.referenceId = stockTransaction.referenceId;
            r.referenceDescription = stockTransaction.referenceDescription;
            r.referenceType = stockTransaction.referenceType;
            r.variantName = stockTransaction.articleVariant.variantDetail2.variantDetailName;
            r.groupKey = r.accountingDate + ' ' + r.transactionType + ' ' + r.referenceId + ' ' + r.referenceDescription;
            r.columns = vm.transGrid.columns;
            r.fullDateTime = stockTransaction.accountingDate;

            if (stockTransaction.stockTransactionType.systemTransactionType.toLowerCase() === "salereservation") {
                r[r.variantName] = stockTransaction.reservedQuantity;
            } else if (stockTransaction.stockTransactionType.systemTransactionType.toLowerCase() === "purchasereservation") {
                r[r.variantName] = stockTransaction.orderedQuantity;
            } else {
                r[r.variantName] = stockTransaction.quantity;
            }

            rows.push(r);
        });

        var oldRow = {};

        vm.rowData.splice(0,vm.rowData.length); // Clears array

        _.forEach(_.sortBy(rows, 'groupKey'), function (row) {
            if (oldRow.groupKey !== row.groupKey) {
                vm.rowData.push(row);
                oldRow = row;
            } else {
                if (oldRow[row.variantName]) {
                    oldRow[row.variantName] += row[row.variantName];
                } else {
                    oldRow[row.variantName] = row[row.variantName];
                }
            }
        });

        vm.rowData = _.orderBy(vm.rowData, 'fullDateTime', 'desc');

        vm.displayedRows = vm.rowData.slice(0, vm.elementsPerPage);

        //Compile summaries of each row
        _.forEach(vm.displayedRows, function(dr) {
            var sum = _.sumBy(dr.columns, function(c) {
                if (c.id === 'accountingDate' || c.id === 'transactionType' || c.id === 'referenceDescription') { return 0; }
                return dr[c.id];
            });
            dr.sum = sum;
        });

        //Compile summaries of each column
        var summaryRow = { columns: [], sum: 0 };
        _.forEach(vm.displayedRows, function(dr) {
            _.forEach(dr.columns, function(c) {
                if (!_.find(summaryRow.columns, function(o) { return o.id === c.id; })) { summaryRow.columns.push(c); }

                if (!summaryRow[c.id]) { summaryRow[c.id] = 0; }
                if (c.id === 'accountingDate' || c.id === 'transactionType' || c.id === 'referenceDescription') {
                    summaryRow[c.id] = '';
                } else {
                    summaryRow[c.id] += dr[c.id] ? dr[c.id] : 0;
                }
            });
            summaryRow.sum += dr.sum;
        });
        vm.displayedRows.push(summaryRow);
    }

    function pageChanged() {
        vm.displayedRows.length = 0;
        var numberOfItems = Math.min(vm.elementsPerPage, vm.rowData.length);
        var startPosition = vm.elementsPerPage * (vm.currentPage - 1);
        var endPosition = Math.min(((startPosition + numberOfItems) - 1), vm.rowData.length);
        for (var i = startPosition; i <= endPosition; i++) {
            vm.displayedRows.push(vm.rowData[i]);
        }
    }
}


